<template>
    <span>
    </span>
</template>

<script>
    const axios = require('axios');
    export default {
        props: {
            siloData: Object
        },
        mounted() {
            //console.log('event tracker mounted');
            // Assign this globally so it can be used anywhere
            window.events = this;
        },
        methods: {
            // Track a page or a module / module slide view
            postPageView(data) {
                console.log('Events: pushing page view to server');
                axios.post(this.siloData.urls.eventpageview, data);
            },
            // Track data submitted
            postSubmitData(data) {
                //console.log('Events: pushing submit data to server');
                axios.post(this.siloData.urls.eventsubmit, data);
            },
            // Track actions like clicks and views
            postAction(data) {
                //console.log('Events: pushing post action to server');
                axios.post(this.siloData.urls.eventaction, data);
            }
        }
    }
</script>